import { render, staticRenderFns } from "./ListAccordion.vue?vue&type=template&id=96492f16&scoped=true&"
import script from "./ListAccordion.vue?vue&type=script&lang=js&"
export * from "./ListAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ListAccordion.vue?vue&type=style&index=0&id=96492f16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96492f16",
  null
  
)

export default component.exports